export default __webpack_public_path__ + "static/media/nested.8c570ba2.jpg";